export enum SensorStatusEnum {
    CREATED = 'CREATED',
    MANUFACTURED = 'MANUFACTURED',
    STERILIZED = 'STERILIZED',
    IN_STOCK = 'IN_STOCK',
    SOLD = 'SOLD',
    ACTIVATED = 'ACTIVATED',
}
